module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee-1-250b0772c7b2dc7554c00b8e8b89e0f7.png";